import {Injectable, TemplateRef} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemplateRefService {
  noDataTempRef!: TemplateRef<any>;

  constructor() { }
}
